/*
* Created on Feb 22, 2021
* @author: Adam Cheng <adamcheng@qnap.com>
*/
import {useState, useEffect, useCallback, memo} from 'react';
import {GoogleMap, Marker, useJsApiLoader} from "@react-google-maps/api";
import axios from "axios";

const SiteGoogleMapComponent = ({isMarkerShown, input, setInput}) => {
    const [latlng, setLatLng] = useState({lat: 0, lng: 0})
    const defaultOptions = {
        mapTypeControl: false,
        // disableDefaultUI: true
    }
    const {isLoaded} = useJsApiLoader({
        id: 'google-map-sript',
        googleMapsApiKey: window._env_.REACT_APP_GOOGLE_MAP_KEY
    })

    const containerStyle = {
        width: '400px',
        height: '400px'
    };

    const [map, setMap] = useState(null)

    const center = {
        lat: -3.745,
        lng: -38.523
    };

    const onLoad = useCallback(function callback(map) {
        // This is just an example of getting and using the map instance!!! don't just blindly copy!
        // const bounds = new window.google.maps.LatLngBounds(center);
        // map.fitBounds(bounds);

        setMap(map)
    }, [])

    const onUnmount = useCallback(function callback(map) {
        setMap(null)
    }, [])

    const getCurrentGeoLocation = () => {
        axios.post(`https://www.googleapis.com/geolocation/v1/geolocate?key=${window._env_.REACT_APP_GOOGLE_MAP_KEY}`)
            .then((data) => {
                console.log(data);
                setLatLng({lat: data.data.location.lat, lng: data.data.location.lng})
                if (!input.location.value.lat) {
                    setInput((prevInput) => {
                        return {
                            ...prevInput,
                            location: {value: {lat: data.data.location.lat, lng: data.data.location.lng, address: ""}}
                        }
                    });
                }
            });
    }

    const onChangeLocation = (e) => {
        const {lat, lng} = e.latLng;
        console.log(lat(), lng());
        const google = window.google ?? undefined;
        setLatLng({lat: lat(), lng: lng()})
        if (google ?? null) {
            const geo = new google.maps.Geocoder();
            geo.geocode({location: {lat: lat(), lng: lng()}})
                .then(data => {
                    console.log(data);
                    setInput((prevInput) => {
                        return {
                            ...prevInput,
                            location: {
                                value: {
                                    lat: lat(),
                                    lng: lng(),
                                    address: data.results?.[0].formatted_address
                                }
                            }
                        }
                    });
                });
        }
    }

    useEffect(() => {
        getCurrentGeoLocation();
    }, [])

    return (
        <>
            {isLoaded &&
                <GoogleMap
                    mapContainerStyle={containerStyle}
                    options={defaultOptions}
                    onLoad={onLoad}
                    onUnmount={onUnmount}
                    zoom={15}
                    // defaultCenter={{lat: input.location?.value.lat || latlng.lat, lng: input.location?.value.lng || latlng.lng}}
                    center={{lat: input.location?.value.lat, lng: input.location?.value.lng}}
                    onRightClick={(e) => onChangeLocation(e)}
                    keyboardShortcuts={false}
                >
                    {isMarkerShown && true && <Marker position={{
                        lat: input.location?.value.lat || latlng.lat,
                        lng: input.location?.value.lng || latlng.lng
                    }}/>}
                </GoogleMap>
            }
        </>
    );
};

export default memo(SiteGoogleMapComponent);
